module.exports = __webpack_public_path__ + "img/features_4.6b6b7744.png";